<template>
  <div class="tw-w-full">
    <h3 class="tw-text-base tw-font-semibold tw-text-slate-900">Logs</h3>

    <div class="tw-mt-3 tw-overflow-x-auto tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur">
      <table class="tw-min-w-full tw-text-left tw-text-sm tw-text-slate-700">
        <thead class="tw-bg-slate-50/70 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">
          <tr>
            <th scope="col" class="tw-px-4 tw-py-3">Activity</th>
            <th scope="col" class="tw-px-4 tw-py-3">Date</th>
          </tr>
        </thead>
        <tbody class="tw-divide-y tw-divide-slate-200/70">
          <tr v-for="(log, logsIdx) in logs" :key="logsIdx" class="hover:tw-bg-slate-50/60">
            <td class="tw-px-4 tw-py-3 tw-whitespace-pre-wrap">{{ log.log }}</td>
            <td class="tw-px-4 tw-py-3 tw-whitespace-nowrap tw-text-slate-600">{{ formatDatetime(log.date) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { datetimeFormatMixin } from '../../../utils/date';

export default defineComponent({
  props: ['logs'],
  mixins: [datetimeFormatMixin],
});
</script>
